



// import React from "react";

// const ServicesSection = () => {
//   return (
//     <section className="sis-our-services-section sisf-page-background sis-br-radius section">
//       <div className="container">

//         {/* Top Section */}
//         <div className="row align-items-end">

//           <div className="col-lg-6">
//             <div className="sisf-sis-section-title sis-section-title">
//               <span className="sisf-m-subtitle white sis-text-anime-style-3">
//                 OUR SERVICES
//               </span>

//               <h2 className="sisf-m-title text-white sis-text-anime-style-3">
//                 Reliable Cab Services for Every Journey
//               </h2>
//             </div>
//           </div>

//           <div className="col-lg-6">
//             <div className="sisf-sis-section-title sis-section-title">

//               <div
//                 className="sisf-m-text"
//                 data-aos="fade-up"
//                 data-aos-delay="100"
//               >
//                 <p className="text-white mt-0">
//                   Travel comfortably and safely with CitySky Cabs. From local
//                   rides and airport transfers to outstation trips and corporate
//                   travel, we provide reliable cabs and professional service
//                   for every journey.
//                 </p>
//               </div>

//               <div
//                 className="sisf-m-button mt-3 pt-4"
//                 data-aos="fade-up"
//                 data-aos-delay="500"
//               >
//                 <a href="/services" className="sis-btn-default btn-light">
//                   View All Services
//                   <i className="fa-solid fa-arrow-right-long"></i>
//                 </a>
//               </div>

//             </div>
//           </div>

//         </div>

//         {/* Services */}
//         <div className="row">

//           {/* Service 1 */}
//           <div className="col-lg-4 col-md-6">
//             <div
//               className="sisf-sis-e-service-list"
//               data-aos="fade-right"
//               data-aos-delay="200"
//             >
//               <div className="sisf-e-inner sis-radius position-relative">

//                 <div className="sisf-service-image position-relative">
//                   <a href="/services" className="sisf-sis-page-link">
//                     <figure>
//                       <img
//                         src="/images/service-image2.jpeg"
//                         className="w-100 sis-radius"
//                         alt="Local Cab Services"
//                       />
//                     </figure>
//                   </a>

//                   <div className="sisf-service-icon-image">
//                     <figure>
//                       <img
//                         src="/images/service-icon1.svg"
//                         alt="Local Cab Services"
//                       />
//                     </figure>
//                   </div>
//                 </div>

//                 <div className="sisf-e-content">
//                   <div className="sisf-sis-e-title">

//                     <h3 className="sisf-e-title mb-2">
//                       <a href="/services">
//                         Local Cab Services
//                       </a>
//                     </h3>

//                     <div className="sisf-m-text">
//                       <p className="sisf-page-text-line text-white">
//                         Get convenient and affordable cab rides for your daily
//                         travel, city commutes, shopping, appointments, and
//                         local transportation needs.
//                       </p>
//                     </div>

//                     <div className="sisf-m-btn">
//                       <a
//                         href="/services"
//                         className="sis-btn-outlined text-white"
//                       >
//                         View All Services
//                         <i className="fa-solid fa-arrow-right-long"></i>
//                       </a>
//                     </div>

//                   </div>
//                 </div>

//               </div>
//             </div>
//           </div>

//           {/* Service 2 */}
//           <div className="col-lg-4 col-md-6">
//             <div
//               className="sisf-sis-e-service-list"
//               data-aos="zoom-in-up"
//               data-aos-delay="500"
//             >
//               <div className="sisf-e-inner sis-radius position-relative">

//                 <div className="sisf-service-image position-relative">
//                   <a href="/services" className="sisf-sis-page-link">
//                     <figure>
//                       <img
//                         src="/images/service-image1.jpeg"
//                         className="w-100 sis-radius"
//                         alt="Airport Cab Services"
//                       />
//                     </figure>
//                   </a>

//                   <div className="sisf-service-icon-image">
//                     <figure>
//                       <img
//                         src="/images/service-icon2.svg"
//                         alt="Airport Cab Services"
//                       />
//                     </figure>
//                   </div>
//                 </div>

//                 <div className="sisf-e-content">
//                   <div className="sisf-sis-e-title">

//                     <h3 className="sisf-e-title mb-2">
//                       <a href="/services">
//                         Airport Cab Services
//                       </a>
//                     </h3>

//                     <div className="sisf-m-text">
//                       <p className="sisf-page-text-line text-white">
//                         Enjoy timely airport pickups and drop-offs with
//                         comfortable vehicles, professional drivers, and a
//                         hassle-free travel experience from CitySky Cabs.
//                       </p>
//                     </div>

//                     <div className="sisf-m-btn">
//                       <a
//                         href="/services"
//                         className="sis-btn-outlined text-white"
//                       >
//                         View All Services
//                         <i className="fa-solid fa-arrow-right-long"></i>
//                       </a>
//                     </div>

//                   </div>
//                 </div>

//               </div>
//             </div>
//           </div>

//           {/* Service 3 */}
//           <div className="col-lg-4 col-md-6">
//             <div
//               className="sisf-sis-e-service-list"
//               data-aos="fade-left"
//               data-aos-delay="200"
//             >
//               <div className="sisf-e-inner sis-radius position-relative">

//                 <div className="sisf-service-image position-relative">
//                   <a href="/services" className="sisf-sis-page-link">
//                     <figure>
//                       <img
//                         src="/images/service-image3.jpeg"
//                         className="w-100 sis-radius"
//                         alt="Outstation Cab Services"
//                       />
//                     </figure>
//                   </a>

//                   <div className="sisf-service-icon-image">
//                     <figure>
//                       <img
//                         src="/images/service-icon3.svg"
//                         alt="Outstation Cab Services"
//                       />
//                     </figure>
//                   </div>
//                 </div>

//                 <div className="sisf-e-content">
//                   <div className="sisf-sis-e-title">

//                     <h3 className="sisf-e-title mb-2">
//                       <a href="/services">
//                         Outstation Cab Services
//                       </a>
//                     </h3>

//                     <div className="sisf-m-text">
//                       <p className="sisf-page-text-line text-white">
//                         Plan comfortable outstation journeys with CitySky
//                         Cabs. Choose convenient one-way or round-trip travel
//                         for family trips, vacations, and business journeys.
//                       </p>
//                     </div>

//                     <div className="sisf-m-btn">
//                       <a
//                         href="/services"
//                         className="sis-btn-outlined text-white"
//                       >
//                         View All Services
//                         <i className="fa-solid fa-arrow-right-long"></i>
//                       </a>
//                     </div>

//                   </div>
//                 </div>

//               </div>
//             </div>
//           </div>

//         </div>

//         {/* Bottom CTA */}
//         <div className="row">
//           <div className="col-12">

//             <div className="sis-comman-bottom-line-text d-flex align-items-center justify-content-center gap-3">

//               <div
//                 className="sisf-users-image"
//                 data-aos="fade-up"
//                 data-aos-delay="100"
//               >
//                 <figure>
//                   <img
//                     src="/images/users3.png"
//                     alt="CitySky Cabs"
//                   />
//                 </figure>
//               </div>

//               <div
//                 className="sisf-sis-e-box d-flex align-items-center justify-content-center"
//                 data-aos="fade-up"
//                 data-aos-delay="300"
//               >
//                 <p className="mb-0 text-white">
//                   Travel Comfortably with CitySky Cabs — Reliable Rides,
//                   Professional Drivers &amp; Hassle-Free Journeys.{" "}
//                   <a
//                     href="/contact"
//                     className="text-white border-bottom border-white"
//                   >
//                     Book Your Cab Today.
//                   </a>
//                 </p>
//               </div>

//             </div>

//           </div>
//         </div>

//       </div>
//     </section>
//   );
// };

// export default ServicesSection;



import React from "react";

const ServicesSection = () => {

  const services = [
    {
      id: 1,
      title: "Airport Transfers",
      image: "/images/services/Airport-Transfers.jpg",
      icon: "/images/service-icon2.svg",
      description:
        "Enjoy convenient airport pickup and drop services with comfortable cabs and professional drivers for smooth travel to and from the airport.",
      animation: "fade-right",
      delay: "100",
    },
    {
      id: 2,
      title: "Corporate Employee Transportation",
      image: "/images/services/Corporate-Employee-Transportation.jpg",
      icon: "/images/service-icon1.svg",
      description:
        "Reliable employee transportation solutions for corporate offices, staff pickup and drop, shift travel and regular business requirements.",
      animation: "zoom-in-up",
      delay: "200",
    },
    {
      id: 3,
      title: "Corporate Car Rental",
      image: "/images/services/Corporate-Car-Rental.jpg",
      icon: "/images/service-icon3.svg",
      description:
        "Professional corporate car rental services for meetings, executive travel, client visits, airport transfers and everyday business transportation.",
      animation: "fade-left",
      delay: "300",
    },
    {
      id: 4,
      title: "Local & Outstation Travel",
      image: "/images/services/Local-&-Outstation-Travel.jpg",
      icon: "/images/service-icon1.svg",
      description:
        "Book comfortable cabs for Pune local travel, one-way journeys, round trips, family tours, weekend trips and outstation destinations.",
      animation: "fade-right",
      delay: "100",
    },
    {
      id: 5,
      title: "Monthly Car Rental",
      image: "/images/services/Monthly-Car-Rental.jpg",
      icon: "/images/service-icon2.svg",
      description:
        "Flexible monthly car rental solutions for companies, professionals and customers who require convenient transportation on a regular basis.",
      animation: "zoom-in-up",
      delay: "200",
    },
    // {
    //   id: 6,
    //   title: "Chauffeur-Driven Cars",
    //   image: "/images/services/Chauffeur-Driven-Cars.jpg",
    //   icon: "/images/service-icon3.svg",
    //   description:
    //     "Travel comfortably with chauffeur-driven cars suitable for business meetings, airport transfers, local journeys and outstation travel.",
    //   animation: "fade-left",
    //   delay: "300",
    // },
    {
      id: 7,
      title: "Event & Business Travel",
      image: "/images/services/Event-&-Business-Travel.jpg",
      icon: "/images/service-icon1.svg",
      description:
        "Convenient transportation for corporate events, conferences, meetings, business visits, functions and other professional travel requirements.",
      animation: "fade-up",
      delay: "200",
    },
  ];

  return (
    <section className="sis-our-services-section sisf-page-background sis-br-radius section">

      <div className="container">

        {/* ===============================
            TOP SECTION
        ================================ */}

        <div className="row align-items-end">

          <div className="col-lg-6">

            <div className="sisf-sis-section-title sis-section-title">

              <span className="sisf-m-subtitle white sis-text-anime-style-3">
                OUR SERVICES
              </span>

              <h2 className="sisf-m-title text-white sis-text-anime-style-3">
                Reliable Cab Services for Every Journey
              </h2>

            </div>

          </div>


          <div className="col-lg-6">

            <div className="sisf-sis-section-title sis-section-title">

              <div
                className="sisf-m-text"
                data-aos="fade-up"
                data-aos-delay="100"
              >

                <p className="text-white mt-0">
                  Travel comfortably with CitySky Cabs. From airport
                  transfers and corporate transportation to local,
                  outstation and business travel, we provide convenient
                  cab solutions for different travel requirements.
                </p>

              </div>


              <div
                className="sisf-m-button mt-3 pt-4"
                data-aos="fade-up"
                data-aos-delay="500"
              >

                <a
                  href="/services"
                  className="sis-btn-default btn-light"
                >
                  View All Services

                  <i className="fa-solid fa-arrow-right-long"></i>
                </a>

              </div>

            </div>

          </div>

        </div>


        {/* ===============================
            SERVICES
        ================================ */}

        <div className="row">

          {services.map((service) => (

            <div
              className="col-lg-4 col-md-6"
              key={service.id}
            >

              <div
                className="sisf-sis-e-service-list"
                data-aos={service.animation}
                data-aos-delay={service.delay}
              >

                <div className="sisf-e-inner sis-radius position-relative">


                  {/* SERVICE IMAGE */}

                  <div className="sisf-service-image position-relative">

                    <a
                      href="/services"
                      className="sisf-sis-page-link"
                    >

                      <figure>

                        <img
                          src={service.image}
                          className="w-100 sis-radius"
                          alt={`${service.title} - CitySky Cabs`}
                        />

                      </figure>

                    </a>


                    {/* ICON */}

                    <div className="sisf-service-icon-image">

                      <figure>

                        <img
                          src={service.icon}
                          alt={service.title}
                        />

                      </figure>

                    </div>

                  </div>


                  {/* CONTENT */}

                  <div className="sisf-e-content">

                    <div className="sisf-sis-e-title">

                      <h3 className="sisf-e-title mb-2">

                        <a href="/services">
                          {service.title}
                        </a>

                      </h3>


                      <div className="sisf-m-text">

                        <p className="sisf-page-text-line text-white">
                          {service.description}
                        </p>

                      </div>


                      <div className="sisf-m-btn">

                        <a
                          href="/services"
                          className="sis-btn-outlined text-white"
                        >
                          View Service

                          <i className="fa-solid fa-arrow-right-long"></i>
                        </a>

                      </div>

                    </div>

                  </div>

                </div>

              </div>

            </div>

          ))}

        </div>


        {/* ===============================
            BOTTOM CTA
        ================================ */}

        <div className="row">

          <div className="col-12">

            <div className="sis-comman-bottom-line-text d-flex align-items-center justify-content-center gap-3">


              <div
                className="sisf-users-image"
                data-aos="fade-up"
                data-aos-delay="100"
              >

                <figure>

                  <img
                    src="/images/users3.png"
                    alt="CitySky Cabs"
                  />

                </figure>

              </div>


              {/* <div
                className="sisf-sis-e-box d-flex align-items-center justify-content-center"
                data-aos="fade-up"
                data-aos-delay="300"
              >

                <p className="mb-0 text-white">

                  Travel Comfortably with CitySky Cabs — Reliable
                  Rides, Professional Drivers &amp; Convenient
                  Journeys.{" "}

                  <a
                    href="/contact"
                    className="text-white border-bottom border-white"
                  >
                    Book Your Cab Today.
                  </a>

                </p>

              </div> */}

            </div>

          </div>

        </div>

      </div>

    </section>
  );
};

export default ServicesSection;